module.exports = __webpack_public_path__ + "static/assets/6a5e329289e7673e9b8a2ff9da62cb22.gif";